module.exports = __webpack_public_path__ + "img/20200401142153328.16c8a95c.png";